<template>
  <div id="summary-menu-bar" class="product-summary-menu-container">
    <div id="summary-menu" class="summary-menu-box">
      <div v-for="(section, index) in summaryProducts" :key="'summary-product-' + index">
        <a
          v-if="section.Jump_isJumpToLink_redirect"
          class="summary-menu-title"
          :class="{ 'active-menu': selectedMenu === section.Jump_to_function_link }"
          :href="section.Jump_to_function_link"
          @click="selectMenu(section.Jump_to_function_link, section.title)"
          >{{ section.title }}</a
        >
        <a
          v-else
          v-scroll-to="{
            el: '#' + section.Jump_to_function_link,
            container: 'body',
            duration: 500,
            lazy: false,
            easing: 'linear',
            offset: -80,
            x: false,
            y: true,
          }"
          class="summary-menu-title"
          :class="{ 'active-menu': selectedMenu === section.Jump_to_function_link }"
          href="#"
          @click="selectMenu(section.Jump_to_function_link, section.title)"
          >{{ section.title }}</a
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'summary-menu',
  props: {
    initialdata: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isSticky: false,
      selectedMenu: '',
    };
  },
  computed: {
    summaryData() {
      return JSON.parse(this.initialdata);
    },
    summaryProducts() {
      const maxItems = this.summaryData[0].Jump_function_maximum_images;
      const original_arr = this.summaryData[0].Jump_to_function_data;
      if (original_arr.length && original_arr.length > maxItems) {
        const finalProductList = original_arr.splice(0, maxItems);
        return finalProductList;
      }
      return original_arr;
    },
  },
  mounted() {
    document.addEventListener('scroll', this.checkScrollPosition);
  },
  created() {
    window.eventBus.$on('summary-menu-highlight', (elementId) => {
      this.selectMenu(elementId);
    });
  },
  methods: {
    checkScrollPosition() {
      const summaryMenu = document.getElementById('summary-menu-bar');
      const menuItem = document.getElementById('summary-menu');
      const sticky = summaryMenu.offsetTop;
      if (window.pageYOffset >= sticky) {
        menuItem.classList.add('sticky');
      } else {
        menuItem.classList.remove('sticky');
      }
    },
    selectMenu(link, value) {
      if (value) {
        dataLayer.push({
          event: 'uaevent',
          eventCategory: 'augmented products',
          eventAction: 'select::summary',
          eventLabel: `${value.toLowerCase()}`,
          ecommerce: 'undefined',
        });
      }
      this.selectedMenu = link;
    },
  },
};
</script>
